import { render, staticRenderFns } from "./ComTabs.vue?vue&type=template&id=56514077&"
import script from "./ComTabs.vue?vue&type=script&lang=js&"
export * from "./ComTabs.vue?vue&type=script&lang=js&"
import style0 from "./ComTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports